<template>
    <div id="task">
        <template v-if="cantAccessPageTask === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{taskPageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissionsTask">
                        <button title="Add" v-if="permission.name == 'can_add_new_task'"  type="button" class="btn general-button btn-primary icon-btn" id="submit" name="submit"
                                v-on:click.prevent="editTask">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>

                        <button title="Import" v-if="permission.name == 'can_import_tasks_data' && taskPageData.cus_id == 0" type="button" class="btn general-button btn-primary icon-btn" data-toggle="modal" data-target="#TaskdefaultModal">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        </button>
                        <button title="Export" v-if="permission.name == 'can_export_tasks_data'" type="button" id='exportTask' class="btn general-button btn-primary icon-btn"
                                v-on:click="exportTask($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button>
                    </template>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_task btn general-button btn-primary" v-on:click="allClick()">All</button>
                        <button type="button" class="btn_my_task btn general-button btn-secondary" v-on:click="myClick()">My Self</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="tasksTable"
                                        ref="listTaskTable"
                                        mode="remote"
                                        title="Tasks"
                                        @on-page-change="onPageChangeTask"
                                        @on-selected-rows-change="selectionChangedTask"
                                        @on-column-filter="onColumnFilterTask"
                                        @on-per-page-change="onPerPageChangeTask"
                                        @on-sort-change="onSortChangeTask"
                                        :totalRows="totalRecordsTask"
                                        :columns="columnsTask"
                                        :rows="rowsTask"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParamsTask.perPage,
                                        setCurrentPage: serverParamsTask.setCurrentPage,
                                        perPageDropdown: serverParamsTask.perPageDropdown,
                                        dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                        enabled: false,

                                        }"
                                        >
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsTask > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsTask.perPage"
                                                      @change="changedValueTask"
                                                      @input="changedValueTaskCustomPerPageTask()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsTask.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecordsTask}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsTask.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsTask.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParamsTask.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListTask() < displayPageTask">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsTask.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsTask.page) <= pageCompareTask">
                                                        <template v-for="(n, index) in displayPageTask">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsTask.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsTask.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsTask.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParamsTask.page) - (pageCompareTask -1))) && (n <= (Number(serverParamsTask.page) + (pageCompareTask -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsTask.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsTask.page) == pageNumberListTask()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParamsTask.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsTask.page) == pageNumberListTask()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsTask">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_add_new_task'" v-for="(permission, index) in permissionsTask">
                                            <router-link title='Edit task' v-if="props.row.created_by == loginIDTask" class="btn edit-btn-vvg" v-bind:to="{name: 'EditTask',params:{id:props.row.id,from:taskPageData.cus_id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                        <template v-if="permission.name == 'can_see_task_view'" v-for="(permission, index) in permissionsTask">
                                            <router-link title='View task details' class="btn edit-btn-vvg" v-bind:to="{name: 'TaskView',params:{id:props.row.id,from:taskPageData.cus_id}}"><i class="fa fa-eye"></i></router-link>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>

                            <!--<div slot="selected-row-actions" slot-scope="computed">-->
                            <!--{{computed.selectedRows}}-->
                            <!--<button v-on:click="onDeleteClick">Delete</button>-->
                            <!--</div>-->
                            <template  v-for="(permission, index) in permissionsTask">
                                <div slot="selected-row-actions">
                                    <button title='Delete task' v-if="permission.name == 'can_add_new_task'" id="deleteTaskBtn" v-on:click.prevent="onDeleteClick" class="btn general-button btn-success">Delete</button>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <!-- Default Size -->
            <div class="modal fade" id="TaskdefaultModal" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Tasks From Excel</h4>
                        </div>
                        <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                            <div class="modal-body">
                                Select Excel File to Import Tasks
                                <label class="myLabel btn general-button btn-info m-r-20">
                                    <input type="file" name="excl_file" accept=".xlsx,.xls" id="upload" ref="filesTask" v-on:change="handleFilesUpload()"/>
                                    <span>Select File ...</span>
                                </label>
                                <div class="form-group">
                                    <label id="errorMsg" class="error"></label><br>
                                </div>
                                <a id ="demourl" href="demoUrl" target="_blank" class="btn general-button btn-info mt-2">
                                    Download Demo
                                </a>
                            </div>
                            <div class="modal-footer">
                                <button type="button" v-on:click="importTasks($event);" class="btn general-button btn-success">Import</button>
                                <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="TaskExportModel" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Tasks From Excel</h4>
                        </div>
                        <div class="modal-body">
                            Task's Exported File is ready to download Please click <a type="button" id="downloadButton" target="_blank" href = "" ><label style="cursor: pointer;" class="font-bold col-pink">DOWNLOAD</label></a> to download the file.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access tasks.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import SessioMixin from '../../mixins/sessionmixin';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import EventBus from '../event-bus';
    import {addTask} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    export default {
        name: "taskcomponent",
        mixins: [SessioMixin],
        props: {
            taskPageData: '',
        },
        data: () => ({
                titleMargin: '',
                displayPageTask: 7,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                jumpToPageTask: 0,

                loginIDTask: 0,
                permissionsTask: [],
                cantAccessPageTask: true,
                messageTask: 'all',
                // filteredFlag: false,
                exportFilteredFlagTask: false,
                filesTask: [],
                isLoggedInTask: false,
                firstLoadTask: 0,
                columnsTask: [
                    {
                        label: 'Created By',
                        field: 'created_first_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Collector',
                    //     field: 'user_first_name',
                    //     filterable: true,
                    //     sortable: false,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "User Name", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'CusId',
                        field: 'customer_id',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_first_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Subject',
                        field: 'subject',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Subject", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Due Date',
                        field: 'due_date',
                        filterable: true,
                        sortable: false,
                        // dateInputFormat: 'DD/MM/YYYY HH:mm:ss',
                        dateOutputFormat: 'DD/MM/YYYY HH:mm:ss',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['In Progress', 'Open', 'Closed'], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Low', 'Normal', 'High'], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Date',
                        field: 'created_at',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Description',
                     field: 'description',
                     filterable: true,
                     sortable: false,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Description", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Actions',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
//                    :sort-options = {
//                        enable : false
//                }

                    },
                ],
                rowsTask: [],
                totalRecordsTask: 0,
                serverParamsTask: {
                    columnFilters: {},
                    sort: {
                        field: 'created_at',
                        type: 'desc',
                    }/*[
                     {
                     field: 'priority',
                     type: 'asc',
                     },
                     {
                     field: 'created_at',
                     type: 'desc',
                     },
                     ]*/,
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                self.isLoggedInTask = true;
                self.getpermissionsTask();

            }
            if (self.taskPageData.cus_id > 0) {
                self.columnsTask['1'].filterOptions.enabled = false;
                self.columnsTask['2'].filterOptions.enabled = false;
            }
        },
        mounted: function () {
            var app = this;
            if (app.taskPageData.cus_id > 0) {
                app.loadFilters('menutaskscustomer', app.columnsTask, app.serverParamsTask, "tasksTable");
            } else {
                app.loadFilters('menutasks', app.columnsTask, app.serverParamsTask, "tasksTable");
            }
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Tasks.xlsx');
            // console.log(this.messageTask);
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDTask = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPageTask = this.serverParamsTask.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageTask(app.jumpToPageTask)
                }
            });
            if (app.taskPageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            this.serverParamsTask.perPage = this.taskPageData.perPage;
            for (var i = this.taskPageData.perPage; i < 100; ) {
                this.serverParamsTask.perPageDropdown.push(i);
                if (this.taskPageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamsTask.perPageDropdown.push(100);
            this.serverParamsTask.perPageDropdown.push(200);
            this.serverParamsTask.perPageDropdown.push(500);
            /*setTimeout(function () {
             $('.filter-th .vgt-select').addClass("custom-select");
             }, 100);*/
            this.loadTaskComponent();
        },
        methods: {
            /* Custome pagination Methods started */
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInTask: function (e) {
                let self = this;
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPageTask: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                var self = this;
                self.serverParamsTask.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1 && self.jumpToPageTask != 1) {
                    self.loadTaskComponent();
                } else if(self.firstLoadTask == 1 && self.jumpToPageTask >=1) {
                    self.loadTaskComponent();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListTask: function () {
                var self = this;
                var totalRecord = self.totalRecordsTask;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsTask.perPage;
                    count++;
                }
                return count;
            },
            changedValueTaskCustomPerPageTask: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadTask != 1) {
                    self.jumpToInputPageTask(self.serverParamsTask.page);
                    self.loadTaskComponent();
                }
                /* Single Backend Call on page load end */
            },
            /* Custome pagination Methods End */
            getpermissionsTask: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.status == 'success') {
                            self.cantAccessPageTask = false;
                            self.permissionsTask = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionsTask.length > 0) {
                                for (var i = 0; i < self.permissionsTask.length; i++) {
                                    if (self.permissionsTask[i].name == 'can_see_task_list') {
                                        self.cantAccessPageTask = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPageTask = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            /*formatFn: function (value) {
             return `ITEM ${value}`;
             },*/
            updateParamsTask(newProps) {
                this.serverParamsTask = Object.assign({}, this.serverParamsTask, newProps);
            },
            onPageChangeTask(params) {
                this.updateParamsTask({page: params.currentPage});

                this.loadTaskComponent();
            },
            onPerPageChangeTask(params) {
                this.updateParamsTask({perPage: params.currentPerPage});
                this.totalRecordsTask = this.totalRecordsTask;
                this.loadTaskComponent();
            },

            onColumnFilterTask(params) {
                this.updateParamsTask(params);
                {
                    field: ('subject');
                    field: ('due_date');
                    field: ('status');
                    field:('priority');
                    field:('description');
                    field:('cusid');
                    field:('customer_first_name');
                    field:('user_first_name');
                }
                ;
                this.serverParamsTask.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsTask));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadTask == 1 || filters.subject || filters.due_date || filters.status || filters.priority
                        || filters.description || filters.cusid || filters.customer_first_name || filters.user_first_name || filters.customer_id || filters.created_at || filters.action) {
                    this.filteredFlag = true;
                    this.loadTaskComponent();
                }

            },
            selectionChangedTask() {

                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editTask() {

                var self = this;
                // self.$router.push("/addtask");
                self.$router.push("/task/create/" + self.taskPageData.cus_id);
            },
            onSortChangeTask(params) {
                this.updateParamsTask({
                    sort: {
                        type: params.sortType,
                        field: this.columnsTask[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadTaskComponent();
            },
            exportTask(e) {
                var self = this;
                self.exportFilteredFlagTask = true;
                //console.log(self.exportFilteredFlagTask);
                // console.log(self.filteredFlag);
                if (self.exportFilteredFlagTask == true) {
                    //console.log("True");
                    self.loadTaskComponent();
                } else {
                    //console.log("False");
                    //change button 
                    $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>...');
                    $(e.target).prop("disabled", true);
                    $.ajax({
                        url: process.env.ROOT_API + "/task/export",
                        type: "GET",
                        data: {type: 'xlsx'},
                        //processData: false,
                        //contentType: false,
                        dataType: 'json',
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        success: function (data) {
                            if (data.status == "success") {
                                self.downloadFile(data.content.web);
                                // location.href = data.content.web;
                                /*$("#downloadButton").attr("href", data.content.web);
                                 $('#TaskExportModel').modal('show');*/
                                $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                                $(e.target).prop("disabled", false);
                            } else {
                                $("#errorMsg").html(data.message);
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }

                                self.errorMsg = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

                // self.loadTaskComponent();
            },
            importTasks(e) {
                var self = this;
                $(e.target).html('');
                $(e.target).html('Importing...');
                $(e.target).prop("disabled", true);
                var formData = new FormData();
                for (var i = 0; i < self.filesTask.length; i++) {
                    let file = self.filesTask[0];
                    //console.log(file);
                    formData.append('excl_file', file);
                }
                //console.log(formData);
                $.ajax({
                    url: process.env.ROOT_API + "/task/import",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {

                        if (data.status == "success") {
                            $("#errorMsg").html('');
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            /*$("#errorMsg").html(data.message);*/
                            self.loadTaskComponent();
                            self.hideModel();
                            var messageType = 'success';
                            var messageTitle = 'Success';
                            if (data.import > 0) {
                                messageType = 'success';
                                messageTitle = 'Success';
                            } else {
                                messageType = 'info';
                                messageTitle = 'Warning';
                            }
                            Swal.fire({
                                type: messageType,
                                title: messageTitle,
                                html: data.message + '<br>' + data.messageSkipRecords,
                                showConfirmButton: true,
                            });
                        } else {
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        $(e.target).html('');
                        $(e.target).html('Import');
                        $(e.target).prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                    }
                });
                // self.$router.push("/addtask");
                //self.$router.push("/task/create");
            },
            handleFilesUpload: function () {
                /*
                 Get the uploaded filesTask from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesTask.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the filesTask array
                 */
                /*this.filesTask.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesTask = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            hideModel() {
                $('#TaskdefaultModal').modal('hide');
                return false;
            },
            allClick: function () {
                var self = this;
                self.messageTask = 'all';
                self.loadTaskComponent();
            },
            myClick: function () {
                var self = this;
                self.messageTask = 'my';
                self.serverParamsTask.page = 1;
                self.jumpToPageTask = 1;
                self.loadTaskComponent();
            },
            loadTaskComponent: function () {
                var self = this;
                self.serverParamsTask.setCurrentPage = self.serverParamsTask.page;
                if (self.messageTask == 'my') {
                    self.toggleButtons(self.messageTask, 'btn_my_task', 'btn_all_task');
                } else {
                    self.toggleButtons(self.messageTask, 'btn_all_task', 'btn_my_task');
                }
                if (self.taskPageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsTask.page,
                        perPage: self.serverParamsTask.perPage,
                        filters: self.serverParamsTask.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamsTask.sort,
                        exportFiltered: self.exportFilteredFlagTask,
                        custid: self.taskPageData.cus_id
                    };
                    self.storeFilters('menutaskscustomer', self.serverParamsTask, false);
                } else {
                    var fields = {
                        page: self.serverParamsTask.page,
                        perPage: self.serverParamsTask.perPage,
                        filters: self.serverParamsTask.columnFilters,
                        messageData: self.messageTask,
                        sort: self.serverParamsTask.sort,
                        exportFiltered: self.exportFilteredFlagTask
                    };
                    self.storeFilters('menutasks', self.serverParamsTask, false);
                }
                self.firstLoadTask = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/task/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagTask = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsTask = data.content.row;
                            self.totalRecordsTask = data.content.totalRecords;
                            self.showHidePagination("tasksTable", self.totalRecordsTask);
                            self.filteredFlag = false;
                            self.jumpToPageTask = self.serverParamsTask.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportTask').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportTask').prop("disabled", false);
                            self.downloadFile(data.content.web);
                            // location.href = data.content.web;
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParamsTask.page, self.serverParamsTask.perPage, self.totalRecordsTask);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            onDeleteClick() {
                //console.log("selected rows", self.$refs['listTaskTable'].selectedRows)
                var self = this;
                var data = self.$refs['listTaskTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['listTaskTable'].selectedRows[i].id)
                }
                // console.log(use)
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                                )
                        $("#deleteTaskBtn").val("Deleting ...");
                        $.ajax({
                            url: process.env.ROOT_API + "/task/delete",
                            type: "POST",
                            data: 'ids=' + use,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                setTimeout(function () {
                                    $(".alert-success").removeClass("show");
                                    $(".alert-success").addClass("hide");
                                }, 5000);
                                setTimeout(function () {
                                    $("#deleteTaskBtn").val("Delete");
                                }, 10000);
                                self.rowsTask = data.content.row;
                                if (data.code == '200') {
                                    // alert("Hii");
                                    self.rowsTask = data.content.row;
                                    self.totalRecordsTask = data.content.totalRecords;
                                    self.loadTaskComponent();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                });

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/task/ListTasksComponent.vue